import { dateFormat } from "../../const/date";
import sanitizeHtml from "sanitize-html";

type BlogData = {
  data: {
    category: Array<string>;
    title: Array<string>;
    link: Array<string>;
    description: Array<string>;
    pubDate: Array<string>;
  }[];
};

const Blog = ({ data }: { data: BlogData[] | any[] }) => {
  const blog = ParseData({ data });

  const getTranslated = (key: string) => {
    const text = key || ""; //data json에서 호출
    const sanitizedText = sanitizeHtml(text, {
      allowedTags: ["br", "em", "span"], //허용할 태그 지정
    });
    return { __html: sanitizedText };
  };
  return (
    <div
      id="blog"
      className="relative w-full h-full bg-light px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:pb-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-5 xl:mb-8"
      >
        <div className="relative w-fit h-fit mx-auto">
          <img
            alt="스마트장인누수 로고"
            className="!relative w-auto h-full max-h-12 lg:max-h-16 xl:max-h-20 mb-3 py-1 object-contain cursor-pointer"
            src="/images/logo.png"
            width={341}
            height={113}
          />
        </div>
        <div className="absolute -bottom-10 lg:-bottom-16 right-8 lg:left-[62%] lg:right-auto">
          <img
            src="/images/blog2.png"
            alt="스마트장인누수 블로그 바로가기"
            className="!relative w-auto h-full max-h-20 lg:max-h-36"
          />
        </div>
      </div>
      <div className="relative w-full h-fit max-w-[1400px] min-h-36 mx-auto grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-5 text-black">
        {blog.map((v, i) => (
          <div
            data-aos="fade-up"
            key={i}
            onClick={() => window.open(v.link[0])}
            className={
              i > 7
                ? "hidden lg:block relative w-full h-full"
                : "relative w-full h-full"
            }
          >
            <div className="relative w-full h-full grid bg-white p-2 md:p-3 text-left border cursor-pointer transition-all duration-300 overflow-hidden">
              <p
                className={`relative w-full text-primary whitespace-nowrap overflow-hidden overflow-ellipsis lg:text-lg h-fit mb-1.5 lg:mb-3`}
              >
                {v.title[0]}
              </p>
              <small
                className={`relative w-full whitespace-nowrap md:whitespace-normal overflow-hidden overflow-ellipsis h-fit md:h-9 my-2 lg:my-0 break-words md:line-clamp-2 text-sm opacity-60`}
                dangerouslySetInnerHTML={getTranslated(v.description[0])}
                // dangerouslySetInnerHTML={{ __html: v.description[0] }}
              ></small>
              <div className="md:pt-2 lg:mt-3 3xl:mt-4 lg:flex justify-between items-end">
                <small className="hidden xl:block opacity-40 lg:text-sm">
                  {dateFormat(v.pubDate[0])}
                </small>
                <small className="text-main lg:text-sm">{v.category[0]}</small>
              </div>
            </div>
          </div>
        ))}
        <div className="absolute right-7 lg:-right-14 -bottom-9 lg:-bottom-28">
          <img
            src="/images/blog1.png"
            alt="스마트 장인누수 블로그"
            className="!relative w-auto h-full max-h-20 lg:max-h-36"
          />
        </div>
      </div>
      <p className="lg:text-2xl my-12 lg:my-8 text-center text-black tracking-tighter">
        <span className="text-primary">스마트&nbsp;장인누수</span>
        의&nbsp;스마트한&nbsp;해결을{" "}
        <span className="text-[#499003]">BLOG</span>에&nbsp;담았습니다
        <br />
        누수해결의&nbsp;생생한&nbsp;현장을{" "}
        <span className="text-primary">스마트&nbsp;장인누수</span>&nbsp;
        <span className="text-[#499003]">BLOG</span>에서&nbsp;확인해보세요
      </p>
    </div>
  );
};

export default Blog;

const parseString = require("xml2js").parseString;

const ParseData = ({ data }: { data: any[] }) => {
  const dataArr: {
    title: any;
    link: any;
    description: any;
    pubDate: any;
    category: any;
  }[] = [];

  parseString(data, (err: any, result: any) => {
    if (err) {
      console.error("XML 파싱 에러:", err);
      return;
    }

    const items = result?.rss?.channel?.[0]?.item;
    if (Array.isArray(items)) {
      items.slice(0, 9).forEach((v: any) => {
        dataArr.push({
          title: v.title,
          link: v.link,
          description: v.description,
          pubDate: v.pubDate,
          category: v.category,
        });
      });
    } else {
      console.warn("item 배열이 없습니다.");
    }
  });

  return dataArr;
};
